export default __webpack_public_path__ + "static/media/LabSupplies.7d2d3bf7.png";